import Vue from 'vue';
// Import left hand images
import LHEmpty from 'assets/svg/target-practice/hand-pfc-left-empty.svg';
// Row0
import LHPinkyOrange from 'assets/svg/target-practice/left-hand/left-hand-pinky-orange.svg';
import LHRingOrange from 'assets/svg/target-practice/left-hand/left-hand-ring-orange.svg';
import LHMiddleOrange from 'assets/svg/target-practice/left-hand/left-hand-middle-orange.svg';
import LHIndexOrange from 'assets/svg/target-practice/left-hand/left-hand-index-orange.svg';
import LHIndexExtraOrange from 'assets/svg/target-practice/extra-finger-lh/extra-finger-lh-orange.svg';
// Row1
import LHPinkyYellow from 'assets/svg/target-practice/left-hand/left-hand-pinky-yellow.svg';
import LHRingYellow from 'assets/svg/target-practice/left-hand/left-hand-ring-yellow.svg';
import LHMiddleYellow from 'assets/svg/target-practice/left-hand/left-hand-middle-yellow.svg';
import LHIndexYellow from 'assets/svg/target-practice/left-hand/left-hand-index-yellow.svg';
import LHIndexExtraYellow from 'assets/svg/target-practice/extra-finger-lh/extra-finger-lh-yellow.svg';
// Row2
import LHPinkyGreen from 'assets/svg/target-practice/left-hand/left-hand-pinky-green.svg';
import LHRingGreen from 'assets/svg/target-practice/left-hand/left-hand-ring-green.svg';
import LHMiddleGreen from 'assets/svg/target-practice/left-hand/left-hand-middle-green.svg';
import LHIndexGreen from 'assets/svg/target-practice/left-hand/left-hand-index-green.svg';
import LHIndexExtraGreen from 'assets/svg/target-practice/extra-finger-lh/extra-finger-lh-green.svg';
// Row3
import LHPinkyBlue from 'assets/svg/target-practice/left-hand/left-hand-pinky-blue.svg';
import LHRingBlue from 'assets/svg/target-practice/left-hand/left-hand-ring-blue.svg';
import LHMiddleBlue from 'assets/svg/target-practice/left-hand/left-hand-middle-blue.svg';
import LHIndexBlue from 'assets/svg/target-practice/left-hand/left-hand-index-blue.svg';
import LHIndexExtraBlue from 'assets/svg/target-practice/extra-finger-lh/extra-finger-lh-blue.svg';
// Import right hand images
import RHEmpty from 'assets/svg/target-practice/hand-pfc-right-empty.svg';
// Row0
import RHIndexOrange from 'assets/svg/target-practice/right-hand/right-hand-index-orange.svg';
import RHMiddleOrange from 'assets/svg/target-practice/right-hand/right-hand-middle-orange.svg';
import RHRingOrange from 'assets/svg/target-practice/right-hand/right-hand-ring-orange.svg';
import RHPinkyOrange from 'assets/svg/target-practice/right-hand/right-hand-pinky-orange.svg';
import RHIndexExtraOrange from 'assets/svg/target-practice/extra-finger-rh/extra-finger-rh-orange.svg';
// Row1
import RHIndexYellow from 'assets/svg/target-practice/right-hand/right-hand-index-yellow.svg';
import RHMiddleYellow from 'assets/svg/target-practice/right-hand/right-hand-middle-yellow.svg';
import RHRingYellow from 'assets/svg/target-practice/right-hand/right-hand-ring-yellow.svg';
import RHPinkyYellow from 'assets/svg/target-practice/right-hand/right-hand-pinky-yellow.svg';
import RHIndexExtraYellow from 'assets/svg/target-practice/extra-finger-rh/extra-finger-rh-yellow.svg';
// Row2
import RHIndexGreen from 'assets/svg/target-practice/right-hand/right-hand-index-green.svg';
import RHMiddleGreen from 'assets/svg/target-practice/right-hand/right-hand-middle-green.svg';
import RHRingGreen from 'assets/svg/target-practice/right-hand/right-hand-ring-green.svg';
import RHPinkyGreen from 'assets/svg/target-practice/right-hand/right-hand-pinky-green.svg';
import RHIndexExtraGreen from 'assets/svg/target-practice/extra-finger-rh/extra-finger-rh-green.svg';
// Row3
import RHIndexBlue from 'assets/svg/target-practice/right-hand/right-hand-index-blue.svg';
import RHMiddleBlue from 'assets/svg/target-practice/right-hand/right-hand-middle-blue.svg';
import RHRingBlue from 'assets/svg/target-practice/right-hand/right-hand-ring-blue.svg';
import RHPinkyBlue from 'assets/svg/target-practice/right-hand/right-hand-pinky-blue.svg';
import RHIndexExtraBlue from 'assets/svg/target-practice/extra-finger-rh/extra-finger-rh-blue.svg';
export default Vue.extend({
    data() {
        const marginsLeftForCurrentKey = {
            LHEmpty: 40,
            LHPinky: 155,
            LHRing: 220,
            LHMiddle: 280,
            LHIndex: 330,
            RHEmpty: 40,
            RHIndex: 560,
            RHMiddle: 610,
            RHRing: 660,
            RHPinky: 730
        };
        return {
            marginsLeftForCurrentKey,
            oneHandedTypingHands: {
                left: {
                    images: {
                        1: {
                            svg: LHPinkyOrange,
                            description: 'Left pinky finger'
                        },
                        2: {
                            svg: LHPinkyOrange,
                            description: 'Left pinky finger'
                        },
                        3: {
                            svg: LHPinkyOrange,
                            description: 'Left pinky finger'
                        },
                        4: {
                            svg: LHPinkyOrange,
                            description: 'Left pinky finger'
                        },
                        5: {
                            svg: LHRingOrange,
                            description: 'Left ring finger'
                        },
                        6: {
                            svg: LHMiddleOrange,
                            description: 'Left middle finger'
                        },
                        7: {
                            svg: LHIndexOrange,
                            description: 'Left index finger'
                        },
                        8: {
                            svg: LHIndexOrange,
                            description: 'Left index finger'
                        },
                        9: {
                            svg: LHIndexOrange,
                            description: 'Left index finger'
                        },
                        0: {
                            svg: LHIndexOrange,
                            description: 'Left index finger'
                        },
                        q: {
                            svg: LHPinkyYellow,
                            description: 'Left pinky finger'
                        },
                        w: {
                            svg: LHPinkyYellow,
                            description: 'Left pinky finger'
                        },
                        e: {
                            svg: LHPinkyYellow,
                            description: 'Left pinky finger'
                        },
                        r: {
                            svg: LHPinkyYellow,
                            description: 'Left pinky finger'
                        },
                        t: {
                            svg: LHRingYellow,
                            description: 'Left ring finger'
                        },
                        a: {
                            svg: LHPinkyGreen,
                            description: 'Left pinky finger'
                        },
                        s: {
                            svg: LHPinkyGreen,
                            description: 'Left pinky finger'
                        },
                        d: {
                            svg: LHPinkyGreen,
                            description: 'Left pinky finger'
                        },
                        f: {
                            svg: LHPinkyGreen,
                            description: 'Left pinky finger'
                        },
                        g: {
                            svg: LHRingGreen,
                            description: 'Left ring finger'
                        },
                        z: {
                            svg: LHPinkyBlue,
                            description: 'Left pinky finger'
                        },
                        x: {
                            svg: LHPinkyBlue,
                            description: 'Left pinky finger'
                        },
                        c: {
                            svg: LHPinkyBlue,
                            description: 'Left pinky finger'
                        },
                        v: {
                            svg: LHPinkyBlue,
                            description: 'Left pinky finger'
                        },
                        b: {
                            svg: LHRingBlue,
                            description: 'Left ring finger'
                        },
                        empty: {
                            svg: LHEmpty,
                            description: 'Left hand'
                        },
                        y: {
                            svg: LHMiddleYellow,
                            description: 'Left middle finger'
                        },
                        u: {
                            svg: LHIndexYellow,
                            description: 'Left index finger'
                        },
                        i: {
                            svg: LHIndexYellow,
                            description: 'Left index finger'
                        },
                        o: {
                            svg: LHIndexYellow,
                            description: 'Left index finger'
                        },
                        p: {
                            svg: LHIndexYellow,
                            description: 'Left index finger'
                        },
                        h: {
                            svg: LHMiddleGreen,
                            description: 'Left middle finger'
                        },
                        j: {
                            svg: LHIndexGreen,
                            description: 'Left index finger'
                        },
                        k: {
                            svg: LHIndexGreen,
                            description: 'Left index finger'
                        },
                        l: {
                            svg: LHIndexGreen,
                            description: 'Left index finger'
                        },
                        n: {
                            svg: LHMiddleBlue,
                            description: 'Left middle finger'
                        },
                        m: {
                            svg: LHIndexBlue,
                            description: 'Left index finger'
                        },
                        ';': {
                            svg: LHIndexGreen,
                            description: 'Left index finger'
                        },
                        ',': {
                            svg: LHIndexBlue,
                            description: 'Left index finger'
                        },
                        '.': {
                            svg: LHIndexBlue,
                            description: 'Left index finger'
                        },
                        '/': {
                            svg: LHIndexBlue,
                            description: 'Left index finger'
                        }
                    }
                },
                right: {
                    images: {
                        1: {
                            svg: RHIndexOrange,
                            description: 'Right index finger'
                        },
                        2: {
                            svg: RHIndexOrange,
                            description: 'Right index finger'
                        },
                        3: {
                            svg: RHIndexOrange,
                            description: 'Right index finger'
                        },
                        4: {
                            svg: RHIndexOrange,
                            description: 'Right index finger'
                        },
                        5: {
                            svg: RHMiddleOrange,
                            description: 'Right middle finger'
                        },
                        6: {
                            svg: RHRingOrange,
                            description: 'Right ring finger'
                        },
                        7: {
                            svg: RHPinkyOrange,
                            description: 'Right pinky finger'
                        },
                        8: {
                            svg: RHPinkyOrange,
                            description: 'Right pinky finger'
                        },
                        9: {
                            svg: RHPinkyOrange,
                            description: 'Right pinky finger'
                        },
                        0: {
                            svg: RHPinkyOrange,
                            description: 'Right pinky finger'
                        },
                        q: {
                            svg: RHIndexYellow,
                            description: 'Right index finger'
                        },
                        w: {
                            svg: RHIndexYellow,
                            description: 'Right index finger'
                        },
                        e: {
                            svg: RHIndexYellow,
                            description: 'Right index finger'
                        },
                        r: {
                            svg: RHIndexYellow,
                            description: 'Right index finger'
                        },
                        t: {
                            svg: RHMiddleYellow,
                            description: 'Right middle finger'
                        },
                        a: {
                            svg: RHIndexGreen,
                            description: 'Right index finger'
                        },
                        s: {
                            svg: RHIndexGreen,
                            description: 'Right index finger'
                        },
                        d: {
                            svg: RHIndexGreen,
                            description: 'Right index finger'
                        },
                        f: {
                            svg: RHIndexGreen,
                            description: 'Right index finger'
                        },
                        g: {
                            svg: RHMiddleGreen,
                            description: 'Right middle finger'
                        },
                        z: {
                            svg: RHIndexBlue,
                            description: 'Right index finger'
                        },
                        x: {
                            svg: RHIndexBlue,
                            description: 'Right index finger'
                        },
                        c: {
                            svg: RHIndexBlue,
                            description: 'Right index finger'
                        },
                        v: {
                            svg: RHIndexBlue,
                            description: 'Right index finger'
                        },
                        b: {
                            svg: RHMiddleBlue,
                            description: 'Right middle finger'
                        },
                        empty: {
                            svg: RHEmpty,
                            description: 'Right hand'
                        },
                        y: {
                            svg: RHRingYellow,
                            description: 'Right ring finger'
                        },
                        u: {
                            svg: RHPinkyYellow,
                            description: 'Right pinky finger'
                        },
                        i: {
                            svg: RHPinkyYellow,
                            description: 'Right pinky finger'
                        },
                        o: {
                            svg: RHPinkyYellow,
                            description: 'Right pinky finger'
                        },
                        p: {
                            svg: RHPinkyYellow,
                            description: 'Right pinky finger'
                        },
                        h: {
                            svg: RHRingGreen,
                            description: 'Right ring finger'
                        },
                        j: {
                            svg: RHPinkyGreen,
                            description: 'Right pinky finger'
                        },
                        k: {
                            svg: RHPinkyGreen,
                            description: 'Right pinky finger'
                        },
                        l: {
                            svg: RHPinkyGreen,
                            description: 'Right pinky finger'
                        },
                        n: {
                            svg: RHRingBlue,
                            description: 'Right ring finger'
                        },
                        m: {
                            svg: RHPinkyBlue,
                            description: 'Right pinky finger'
                        },
                        ';': {
                            svg: RHPinkyBlue,
                            description: 'Right pinky finger'
                        },
                        ',': {
                            svg: RHPinkyBlue,
                            description: 'Right pinky finger'
                        },
                        '.': {
                            svg: RHPinkyBlue,
                            description: 'Right pinky finger'
                        },
                        '/': {
                            svg: RHPinkyBlue,
                            description: 'Right pinky finger'
                        }
                    }
                }
            },
            hands: {
                left: {
                    images: {
                        1: {
                            svg: LHPinkyOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHPinky,
                            description: 'Left pinky finger'
                        },
                        2: {
                            svg: LHRingOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHRing,
                            description: 'Left ring finger'
                        },
                        3: {
                            svg: LHMiddleOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHMiddle,
                            description: 'Left middle finger'
                        },
                        4: {
                            svg: LHIndexOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        5: {
                            svg: LHIndexExtraOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        q: {
                            svg: LHPinkyYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHPinky,
                            description: 'Left pinky finger'
                        },
                        w: {
                            svg: LHRingYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHRing,
                            description: 'Left ring finger'
                        },
                        e: {
                            svg: LHMiddleYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHMiddle,
                            description: 'Left middle finger'
                        },
                        r: {
                            svg: LHIndexYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        t: {
                            svg: LHIndexExtraYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        a: {
                            svg: LHPinkyGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHPinky,
                            description: 'Left pinky finger'
                        },
                        s: {
                            svg: LHRingGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHRing,
                            description: 'Left ring finger'
                        },
                        d: {
                            svg: LHMiddleGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHMiddle,
                            description: 'Left middle finger'
                        },
                        f: {
                            svg: LHIndexGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        g: {
                            svg: LHIndexExtraGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        z: {
                            svg: LHPinkyBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHPinky,
                            description: 'Left pinky finger'
                        },
                        x: {
                            svg: LHRingBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHRing,
                            description: 'Left ring finger'
                        },
                        c: {
                            svg: LHMiddleBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHMiddle,
                            description: 'Left middle finger'
                        },
                        v: {
                            svg: LHIndexBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        b: {
                            svg: LHIndexExtraBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHIndex,
                            description: 'Left index finger'
                        },
                        empty: {
                            svg: LHEmpty,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.LHEmpty,
                            description: 'Left hand'
                        }
                    }
                },
                right: {
                    images: {
                        6: {
                            svg: RHIndexExtraOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        7: {
                            svg: RHIndexOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        8: {
                            svg: RHMiddleOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHMiddle,
                            description: 'Right middle finger'
                        },
                        9: {
                            svg: RHRingOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHRing,
                            description: 'Right ring finger'
                        },
                        0: {
                            svg: RHPinkyOrange,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHPinky,
                            description: 'Right pinky finger'
                        },
                        y: {
                            svg: RHIndexExtraYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        u: {
                            svg: RHIndexYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        i: {
                            svg: RHMiddleYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHMiddle,
                            description: 'Right middle finger'
                        },
                        o: {
                            svg: RHRingYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHRing,
                            description: 'Right ring finger'
                        },
                        p: {
                            svg: RHPinkyYellow,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHPinky,
                            description: 'Right pinky finger'
                        },
                        h: {
                            svg: RHIndexExtraGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        j: {
                            svg: RHIndexGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        k: {
                            svg: RHMiddleGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHMiddle,
                            description: 'Right middle finger'
                        },
                        l: {
                            svg: RHRingGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHRing,
                            description: 'Right ring finger'
                        },
                        ';': {
                            svg: RHPinkyGreen,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHPinky,
                            description: 'Right pinky finger'
                        },
                        n: {
                            svg: RHIndexExtraBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        m: {
                            svg: RHIndexBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHIndex,
                            description: 'Right index finger'
                        },
                        ',': {
                            svg: RHMiddleBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHMiddle,
                            description: 'Right middle finger'
                        },
                        '.': {
                            svg: RHRingBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHRing,
                            description: 'Right ring finger'
                        },
                        '/': {
                            svg: RHPinkyBlue,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHPinky,
                            description: 'Right pinky finger'
                        },
                        empty: {
                            svg: RHEmpty,
                            marginLeftCurrentKey: marginsLeftForCurrentKey.RHEmpty,
                            description: 'Right hand'
                        }
                    }
                }
            }
        };
    }
});
